<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.mpsVersion"
                selectType="select"
                requestApi="/scp/scpMpsPlans/listMpsPlanVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工艺大类">
              <!-- <a-select show-search option-filter-prop="children" v-model="queryParams.listCategory" >
                <a-select-option v-for="(item) in productBroadCategoryOpinions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select> -->
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.listCategory"
                selectType="selectMultiple"
                :selectData="productBroadCategoryOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <template>
            <a-col :md="6" :sm="24">
              <a-form-item label="类型">
                <global-select
                  :max-tag-count="2"
                  :max-tag-text-length="4"
                  show-search
                  :value.sync="queryParams.listType"
                  selectType="selectMultiple"
                  :selectData="monthToDayTypeOpinions"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                />
              </a-form-item>
            </a-col>
          </template>
          <!-- 物料编码 -->
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.itemId"
                :dropdown-match-select-width="false"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMpsPlans/listItemCodeCp"
                :assembleLabel="true"
                :selectItem="{ value: 'realValue', label: 'selectedValue', thirdLabel: 'bringOutDataOne' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="getTableInfo" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary">导出</a-button>
      <a-button @click="handleOperation" type="primary">报检调整</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="isLoading">

          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="detailId"
            :scroll="{ fixScreen: true, x: 1300 }"
          >
            <!-- 月份 -->
            <template slot="month" slot-scope="{ record, column }">
              <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex] }}</span>
              <a-input-number
                v-if="isEdit && currentId === record.id"
                v-model="record[column.dataIndex]"
                size="small"
              />
              <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
            </template>

            <template slot="isStopFlag" slot-scope="{ record }">
              <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
            </template>

          </ls-api-table>
        </a-spin>
      </div>
    </template>
  </ls-table-layout>
</template>

    <script>
    import { apiFcNewProductDetail, apiDelFcNewProductDetail } from '@/api/scp/new-product-forecast/new-product-forecast'
    import { apiPageInspectionRequired } from '@/api/mps/basic-data/mps-Inspection-requirements.js'
    import { generateLsTableResData } from '@/utils/util.js';
    export default {
      // eslint-disable-next-line
      name: 'Mps-Inspection-requirements',
      components: {

      },
      data () {
        return {
          monthToDayTypeOpinions: [],
          productBroadCategoryOpinions: [],
          isLoading: false,
          tableList: [],
          businessUnitList: [], // 事业部
          isSetTitle: false,
          // 表格配置
          tableProps: {
            requestApi: generateLsTableResData(apiPageInspectionRequired, true),
            pageCurrent: true
          },
          isEdit: false,
          currentId: "",
          // 控制搜索展开
          advanced: true,
          // 查询参数
          queryParams: {
            // 预测名称
            mpsVersion: undefined,
             // 版本
             listCategory: undefined,
             listType: undefined,
             itemId: undefined
          },
          // 表格多选
          selectedRowKeys: [],
          selectedRows: [],
          // 状态快码
          statusOptions: [
            {
              dictLabel: "有效",
              dictValue: "Y"
            },
            {
              dictLabel: "无效",
              dictValue: "N"
            }
          ],
          baseUomFlagOptions: [
            {
              dictLabel: "是",
              dictValue: "Y"
            },
            {
              dictLabel: "否",
              dictValue: "N"
            }
          ],
          columns: [],
          columnsServe: [],
          // 表格字段
          columnsNative: [
            {
              title: '物料编码',
              width: 150,
              fixed: 'left',
              dataIndex: 'itemCode',
              ellipsis: true,
              align: 'center'
            },
            {
              title: '工艺大类',
              fixed: 'left',
              ellipsis: true,
              dataIndex: 'category',
              width: 140,
              align: 'center'
            },
            {
              title: '类型',
              ellipsis: true,
              fixed: 'left',
              dataIndex: 'lineTypeVal',
              width: 180,
              align: 'center'
            }
          ],
          unitOfMeasureList: [],
          unitOfMeasureListNew: []
        }
      },
      created () {
         this.queryParams.mpsVersion = this.$route.query.id
        //  this.queryParams.forecastName = this.$route.params.forecastName;
        //  this.queryParams.versionDescription = this.$route.params.versionDescription;
         this.columns = this.columnsNative;
         this.getLookupList('SCP_BUSINESS_UNIT', 'businessUnitList');
         this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'productBroadCategoryOpinions')
         this.getLookupList('SCP_MONTH_TO_DAY_TYPE', 'monthToDayTypeOpinions')
      },
      mounted () {
        this.getTableInfo()
      },
      methods: {
        handleDelete (tableList, record) {
          const self = this
        this.$confirm({
          title: '警告',
          content: `真的要删除该项的数据项吗?`,
          okText: '删除',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            const ids = []
            self.columnsServe.forEach((column) => {
              console.log(column.indexKey)
              const id = record[column.indexKey].id
              ids.push(id)
            })
            apiDelFcNewProductDetail(record).then(response => {
              if (response.code === 200) {
                self.$message.success('删除成功')
                self.onSearch()
              } else {
                self.$message.error(response.msg)
              }
            })
          }
        })
        },
        handleOperation (text, record) {
          this.$router.push({ path: `/mps-Inspection-requirements/inspectionAdjustment/${this.queryParams.mpsVersion}` })
        },
        handleNameChange (val, selectList) {
          const filteredItem = selectList.filter(item => item.realValue === val);
          this.queryParams.startMonth = filteredItem[0].bringOutDataOne
        },
        handleVersionChange (val, selectList) {
          if (val) {
            const filteredItem = selectList.filter(item => item.realValue === val);
            this.queryParams.versionDescription = filteredItem[0].bringOutDataOne
            this.versionCode = this.queryParams.versionCode;
            this.versionDescription = this.queryParams.versionDescription;
          }
        },
        getLookupList (type, arr) {
        const lookupQueryParams = {
          lookupType: type,
          current: 1,
          pageSize: 100
        }
        this.getLookupListData(lookupQueryParams).then().then(response => {
          this[arr] = response.rows
        })
        },
        blur (record) {
          if (!record.conversionRate || Number(record.conversionRate) <= 0) {
            this.$message.warning('折换不能为空且需大于0')
          } else {
            record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
          }
        },
        statusOnChange (record) {
          record.status = record.status === 'Y' ? 'N' : 'Y'
        },
        // 导入导出excel
        /** 导出按钮操作 */
        handleExport () {
          this.download('scp/scpMpsPlans/exportInspectionRequired', {
            ...this.queryParams, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: this.$refs.dataTable.myPagination.current
          }, `报检需求_${new Date().getTime()}.xlsx`)
        },
        // 编辑
        handleEdit (record, index) {
          if (this.currentId && record.id !== this.currentId && this.isEdit) {
            this.$message.warning('请保存上次编辑的数据')
            return;
          }
          this.isEdit = true;
          this.currentId = record.id;
        },
        // 编辑-保存
        handleSave (record) {
        const recordCopy = JSON.parse(JSON.stringify(record))
        apiFcNewProductDetail(recordCopy).then((response) => {
          if (response.code === 200) {
            this.$message.success('更新成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
        },
        // 取消
        handleCancel (record) {
          this.isEdit = false
          this.onSearch()
        },
        // 新增/修改框事件
        handleOk () {
          this.onSearch()
        },
        // 表单搜索
        onSearch () {
          this.isEdit = false
          this.$refs.dataTable.searchParams = this.queryParams;
          this.$refs.dataTable.getData();
        },
        getTableInfo () {
        this.isEdit = false
        this.$refs.dataTable.searchParams = this.queryParams;
        if (this.isLoading) {
          return
        }
        this.$refs.dataTable.myPagination.current = 1
        this.isLoading = true
        apiPageInspectionRequired({ ...this.queryParams, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 }).then((response) => {
          this.isLoading = false
          if (response.code === 200) {
            this.tableList = response.rows
            this.tableList.forEach((obj, index) => {
              obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
            })
            this.$refs.dataTable.myDataSource = this.tableList
            const titles = response.title
            this.columnsServe = response.title
            // 生成新的对象数组，并为每个对象添加name属性
            const newArray = titles.map((title) => {
              return {
                title: title.indexName,
                dataIndex: title.indexKey,
                scopedSlots: { customRender: 'month' },
                width: 120,
                align: 'center'
              }
            })
            const dynamicColumn = this.setNewColumn('lineTypeVal', this.columnsNative, newArray)
            this.columns = dynamicColumn
            this.$refs.dataTable.myPagination.total = response.total
            this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.total, this.$refs.dataTable.myPagination.pageSize)
          } else {
            this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
            this.$message.error(response.msg)
          }
        }).catch((error) => {
          this.isLoading = false
          // 处理 API 调用失败的情况
          console.error('API 调用失败: ', error);
        })
      },
        /** 重置按钮操作 */
        resetQuery () {
          this.queryParams = {
            // 预测名称
            mpsVersion: undefined,
             // 版本
             listCategory: undefined,
             listType: undefined,
             itemId: undefined
          }
          this.onSearch()
        },
        // 搜索框展开、收起
        toggleAdvanced () {
          this.advanced = !this.advanced
        },
            /**
       * 在table 某个列的字段后增加列
       * key：列的字段名称
       * columnList 列表的列
       * insertColumnList 插入的新列
       *  */
      setNewColumn (key, columnList, insertColumnList) {
        const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
        const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
        if (index !== -1) {
          newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
        }
        return newArray
      }
      }
    }
    </script>

    <style scoped lang="less">
    .ml10{
      margin-left: 10px;
    }
    </style>
